import styled from 'styled-components';

export const NoResultsContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	padding: 1rem;
`;
